import { writable } from "svelte/store";

// browser checked
export const section = writable("dashboard");
